// extracted by mini-css-extract-plugin
export default {"TooltipIcon":"lsYFSiI7YNdwnPOuOuWw"};